import React from 'react';
import './Card.css';

function Card({ card, small, clickable, faceDown }) {
  const cardBackground = process.env.PUBLIC_URL + '/card.png';
  const coverBackground = process.env.PUBLIC_URL + '/cover.png';
  const getSymbol = (suit) => {
    switch (suit) {
      case 'hearts':
        return '♥';
      case 'diamonds':
        return '♦';
      case 'clubs':
        return '♣';
      case 'spades':
        return '♠';
      default:
        return '?';
    }
  };

  const getColor = (suit) => {
    switch (suit) {
      case 'hearts':
        return '#DC143C';
      case 'diamonds':
        return '#DC143C';
      case 'clubs':
        return '#000000';
      case 'spades':
        return '#000000';
      default:
        return '#000000';
    }
  };

  if (faceDown) {
    return (
      <div 
        className={`card ${small ? 'card-small' : ''} ${clickable ? 'card-clickable' : ''}`}
        style={{ backgroundImage: `url(${coverBackground})` }}
      >
      </div>
    );
  }

  return (
    <div 
      className={`card ${small ? 'card-small' : ''} ${clickable ? 'card-clickable' : ''}`}
      style={{ backgroundImage: `url(${cardBackground})` }}
    >
      <div className="card-inner">
        <div className="card-corner card-corner-top-left">
          <div className="card-value" style={{ color: getColor(card.suit) }}>
            {card.value}
          </div>
          <div className="card-mini-symbol" style={{ color: getColor(card.suit) }}>
            {getSymbol(card.suit)}
          </div>
        </div>
        <div className="card-center">
          <div className="card-symbol" style={{ color: getColor(card.suit) }}>
            {getSymbol(card.suit)}
          </div>
        </div>
        <div className="card-corner card-corner-bottom-right">
          <div className="card-value" style={{ color: getColor(card.suit) }}>
            {card.value}
          </div>
          <div className="card-mini-symbol" style={{ color: getColor(card.suit) }}>
            {getSymbol(card.suit)}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Card;
